import type { ReactNode } from "react";
import { Kicker } from "@/components/ui/kicker";

export function DashboardSectionHeader({
  kicker,
  note,
  action,
}: {
  kicker: string;
  note?: string;
  action?: ReactNode;
}) {
  return (
    <div className="mb-4 flex items-baseline justify-between gap-3">
      <div className="flex items-baseline gap-3">
        <Kicker as="h2">{kicker}</Kicker>
        {note && (
          <span className="hidden text-sm text-muted-foreground sm:inline">
            {note}
          </span>
        )}
      </div>
      {action}
    </div>
  );
}
